import { render } from "./Time.vue?vue&type=template&id=66f0adb8&scoped=true"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"

import "./Time.vue?vue&type=style&index=0&id=66f0adb8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66f0adb8"

export default script